import './Team.css';

const values = [
  { title: 'Build, Don\'t Fund', desc: 'We create companies from zero — product, brand, and team.' },
  { title: 'Domain Native', desc: 'We build for industries we operate in — not markets we studied.' },
  { title: 'AI-Native', desc: 'Every company is built AI-first — in how it\'s made and in what it does.' },
  { title: 'Vertical Depth', desc: 'We go deep, not wide. One vertical at a time, one product at a time.' }
];

export default function Team() {
  return (
    <>
      <section className="page-header">
        <div className="page-label">Team</div>
        <h1 className="page-title">Built by an operator, not a fund.</h1>
      </section>

      <section className="team-section">
        <div className="section-label">Founder</div>
        <div className="founder-card">
          <div className="founder-avatar">AK</div>
          <div className="founder-body">
            <div className="tc-role">Founder · Lakeshore</div>
            <div className="founder-name">Abhi Kanakadandila</div>
            <p className="founder-bio">
              Abhi is the founder and CEO of <a href="https://www.d36.world" target="_blank" rel="noreferrer" className="inline-link">D36</a>,
              the Los Angeles label and media company building cultural infrastructure for South Asian music and its diaspora.
            </p>
            <p className="founder-bio">
              Before D36, he was VP of Strategy at music distribution company Stem; Finance at SpaceX, where he worked on the
              early Starlink business plan and manufacturing and reusability analysis; and an investment banker at Bank of
              America Merrill Lynch. He studied at NYU Stern and grew up in St. Louis.
            </p>
            <p className="founder-bio">
              Lakeshore is where the problems he runs into operating in music every day — touring logistics, catalog valuation,
              contracts, distribution operations, linear television — become AI-native products. Everything in the portfolio is
              designed, built, and shipped in-house.
            </p>
            <div className="founder-links">
              <a href="https://www.d36.world" target="_blank" rel="noreferrer">d36.world ↗</a>
              <a href="mailto:abhi@lakeshore.studio">abhi@lakeshore.studio</a>
            </div>
          </div>
        </div>
      </section>

      <section className="philosophy-section">
        <div>
          <div className="phil-heading">How We Work</div>
        </div>
        <div>
          <p className="phil-body">Lakeshore operates as a studio, not a fund. We don't write checks and wait — we build the company and ship the product. Every venture is built from within.</p>
          <p className="phil-body">The studio runs like a factory line: every company shares the same AI-native build system, design language, and operating playbook — so each new product ships faster than the last.</p>
          <div className="values-grid">
            {values.map((v, i) => (
              <div className="value-card" key={i}>
                <div className="val-num">{String(i + 1).padStart(2, '0')}</div>
                <div className="val-title">{v.title}</div>
                <div className="val-desc">{v.desc}</div>
              </div>
            ))}
          </div>
        </div>
      </section>
    </>
  );
}
